import styled from 'styled-components';

export interface Section extends React.HTMLAttributes<HTMLDivElement> {
  padding?: {
    typeMeasure?: string
    desktop?: {
      paddingTop?: number
      paddingBottom?: number
    },
    mobile?: {
      paddingTop?: number
      paddingBottom?: number
    }
  }
  iconColor?: string
}

export const Section = styled.section`
  @media (min-width: 768px) {
    padding-top: ${(props: Section) => {
      return typeof props.padding?.desktop?.paddingTop === 'number' 
        ? `${props.padding.desktop.paddingTop}${props.padding?.typeMeasure || 'px'}`
        : `120${props.padding?.typeMeasure || 'px'}`;
    }};
    padding-bottom: ${(props: Section) => {
      return typeof props.padding?.desktop?.paddingBottom === 'number'
        ? `${props.padding.desktop.paddingBottom}${props.padding?.typeMeasure || 'px'}`
        : `120${props.padding?.typeMeasure || 'px'}`;
    }};
  }

  @media (max-width: 767px) {
    padding-top: ${(props: Section) => {
      return typeof props.padding?.mobile?.paddingTop === 'number'
        ? `${props.padding.mobile.paddingTop}${props.padding?.typeMeasure || 'px'}`
        : `40${props.padding?.typeMeasure || 'px'}`;
    }};
    padding-bottom: ${(props: Section) => {
      return typeof props.padding?.mobile?.paddingBottom === 'number'
        ? `${props.padding.mobile.paddingBottom}${props.padding?.typeMeasure || 'px'}`
        : `40${props.padding?.typeMeasure || 'px'}`;
    }};
  }
`;